import { Context, type Effect, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { FlowRecordingFrameRef } from "@workerstation/shared/flow-recording-player-model";
export interface RecordingVideoTarget {
    readonly workspaceId: string;
    readonly recordingId: string;
}
export interface RecordingVideoView {
    readonly error: string | null;
    readonly closed: boolean;
}
export interface RecordingVideoSession {
    readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<RecordingVideoView>>;
    readonly read: Effect.Effect<RecordingVideoView>;
    readonly draw: (canvas: HTMLCanvasElement | null, index: number) => Effect.Effect<void>;
}
export class RecordingVideoSessions extends Context.Service<RecordingVideoSessions, {
    readonly open: (target: RecordingVideoTarget, timeline: readonly FlowRecordingFrameRef[]) => Effect.Effect<RecordingVideoSession, never, Scope.Scope>;
}>()("workerstation/frontend/RecordingVideoSessions") {
}
export class RecordingFrameIo extends Context.Service<RecordingFrameIo, {
    readonly decodeJpeg: (bytes: Uint8Array) => Effect.Effect<ImageBitmap, ResourceFailure>;
    readonly closeBitmap: (bitmap: ImageBitmap) => Effect.Effect<void>;
    readonly draw: (canvas: HTMLCanvasElement, bitmap: ImageBitmap) => Effect.Effect<void, ResourceFailure>;
}>()("workerstation/frontend/RecordingFrameIo") {
}
